export default "__VITE_ASSET__B7oLlo7A__"